class XsFlashipSellingpointsVideo extends HTMLElement {
  connectedCallback() {
    this.videoPc = this.querySelector('.sp-card__media-video--pc');
    this.videoMb = this.querySelector('.sp-card__media-video--mb');
    this.pauseBtn = this.querySelector('[data-pause]');
    this.volumeBtn = this.querySelector('[data-volume]');
    this.controls = this.querySelector('.sp-video-controls');
    this.preferredMuted = true;

    const videos = [this.videoPc, this.videoMb].filter(Boolean);
    if (!videos.length) {
      if (this.controls) this.controls.hidden = true;
      return;
    }

    if (!this.pauseBtn || !this.volumeBtn) return;

    videos.forEach((video) => {
      video.muted = true;
      this.preferredMuted = true;
      video.addEventListener('play', () => {
        if (video === this.getActiveVideo()) this.updatePauseState(video);
      });
      video.addEventListener('pause', () => {
        if (video === this.getActiveVideo()) this.updatePauseState(video);
      });
      video.addEventListener('volumechange', () => {
        if (video === this.getActiveVideo()) this.updateVolumeState(video);
      });
    });

    this.pauseBtn.addEventListener('click', () => this.togglePlay());
    this.volumeBtn.addEventListener('click', () => this.toggleMute());

    this.onResize = () => this.syncActiveVideo();
    window.addEventListener('resize', this.onResize);

    const activeVideo = this.getActiveVideo();
    if (activeVideo) {
      this.updatePauseState(activeVideo);
      this.updateVolumeState(activeVideo);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  getActiveVideo() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (isMobile) return this.videoMb || this.videoPc;
    return this.videoPc || this.videoMb;
  }

  getVideos() {
    return [this.videoPc, this.videoMb].filter(Boolean);
  }

  syncActiveVideo() {
    const activeVideo = this.getActiveVideo();
    const inactiveVideos = this.getVideos().filter((video) => video !== activeVideo);

    inactiveVideos.forEach((video) => {
      if (!video.paused) video.pause();
    });

    if (activeVideo) {
      activeVideo.muted = this.preferredMuted;
      this.updatePauseState(activeVideo);
      this.updateVolumeState(activeVideo);
    }
  }

  async togglePlay() {
    const video = this.getActiveVideo();
    if (!video) return;

    try {
      if (video.paused) {
        await video.play();
      } else {
        video.pause();
      }
    } catch {
      // Autoplay policy or missing source.
    }

    this.updatePauseState(video);
  }

  async toggleMute() {
    const video = this.getActiveVideo();
    if (!video) return;

    const nextMuted = !video.muted;
    this.preferredMuted = nextMuted;
    this.getVideos().forEach((item) => {
      item.muted = nextMuted;
    });

    if (!nextMuted) {
      try {
        if (video.paused) await video.play();
      } catch {
        this.preferredMuted = true;
        this.getVideos().forEach((item) => {
          item.muted = true;
        });
      }
    }

    this.updateVolumeState(video);
  }

  updatePauseState(video) {
    const isPaused = video.paused;
    this.pauseBtn.setAttribute(
      'aria-label',
      isPaused ? this.dataset.playLabel : this.dataset.pauseLabel
    );
    this.pauseBtn.setAttribute('data-playing', isPaused ? 'false' : 'true');
  }

  updateVolumeState(video) {
    const isMuted = video.muted;
    this.preferredMuted = isMuted;
    this.volumeBtn.setAttribute('data-muted', isMuted ? 'true' : 'false');
    this.volumeBtn.setAttribute(
      'aria-label',
      isMuted ? this.dataset.unmuteLabel : this.dataset.muteLabel
    );
  }
}

if (!customElements.get('xs-flaship-sellingpoints-video')) {
  customElements.define('xs-flaship-sellingpoints-video', XsFlashipSellingpointsVideo);
}
